export enum PromotedFeatureActionEnum {
    SHOW_TUTORIALS_VIDEOS = 'SHOW_TUTORIALS_VIDEOS',
}
